import {Injectable, isDevMode} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateChild, Route} from '@angular/router';

import {FeatureFlagsService} from "./feature-flags.service";

@Injectable({ providedIn: 'root' })
export class FeatureFlagCanActivateChildGuard implements CanActivateChild {

  constructor(private featureFlagsService: FeatureFlagsService) {
  }

  isDevMode() {
    return isDevMode();
  }

  canActivateChild(route: ActivatedRouteSnapshot | Route): boolean {
    if (!route || !route.data || !route.data.featureFlag) {
      if (this.isDevMode()) {
        console.error(
          'FeatureFlagCanActivateChildGuard needs to get "featureFlag" as data in the route configuration.'
        );
      }
      return false;
    }

    if (!Array.isArray(route.data.featureFlag)) {
      if (this.isDevMode()) {
        console.error(
          'FeatureFlagCanActivateChildGuard needs to get "featureFlag" as data as an array in the route configuration.'
        );
      }
      return false;
    }

    return route.data.featureFlag.every(flag => flag[0] === '!' ? !this.isOn(flag.replace('!', '')) : this.isOn(flag));
  }


  private isOn(flag: string) {
    return this.featureFlagsService.isOn(flag);
  }
}
